var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSap = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.06335V17.9368H12.1286L23.9998 6.06477L0 6.06335Z",
    fill: "url(#paint0_linear_3_78)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.64 11.5891H14.1337V9.73957H14.64C15.3158 9.73957 15.8539 9.96194 15.8539 10.6531C15.8539 11.3667 15.3158 11.5891 14.64 11.5891ZM9.19125 12.9136C8.94 12.9147 8.69063 12.8708 8.45513 12.7838L9.18412 10.4851H9.19913L9.9135 12.7913C9.68175 12.8738 9.43725 12.9151 9.192 12.9151M14.5057 8.23657H12.2062V13.7041L10.1978 8.23657H8.20875L6.4935 12.8063C6.312 11.6558 5.1195 11.2564 4.18125 10.9583C3.56325 10.7596 2.90475 10.4708 2.91075 10.1434C2.916 9.87869 3.26438 9.63344 3.951 9.66944C4.41375 9.69269 4.82587 9.72944 5.63287 10.1221L6.43463 8.73082C5.69475 8.35319 4.66988 8.11582 3.83063 8.11394H3.82312C2.84437 8.11394 2.02988 8.43269 1.52438 8.95507C1.17488 9.31507 0.977625 9.79507 0.973875 10.2964C0.96075 11.0007 1.22025 11.5002 1.76325 11.9003C2.22263 12.2371 2.80875 12.4534 3.32625 12.6166C3.96487 12.8127 4.48612 12.9856 4.48012 13.3527C4.47639 13.4866 4.42229 13.6142 4.32863 13.7101C4.16963 13.8739 3.9255 13.9369 3.58725 13.9448C2.9355 13.9579 2.45287 13.8567 1.683 13.4018L0.97125 14.8103C1.764 15.2603 2.65988 15.4988 3.5715 15.5022H3.6915C4.49775 15.4872 5.1495 15.2566 5.67 14.8384L5.75438 14.7657L5.52675 15.3807H7.61362L7.96425 14.3142C8.75175 14.5692 9.59925 14.5729 10.3894 14.3243L10.7269 15.3818H14.1319V13.1776H14.8755C16.6702 13.1776 17.733 12.2641 17.733 10.7311C17.733 9.02482 16.6999 8.24107 14.5035 8.24107",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_78",
    x1: 11.8794,
    y1: 6.10121,
    x2: 11.8794,
    y2: 18.0846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#06A5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#1870C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D61BC"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sap.d4248e5801881385213b9dfeca197b9e.svg";